var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudInsightsBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "3 3 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M19.77 14.47a3.7 3.7 0 0 0-2.27-1.42 4.9 4.9 0 0 1-6.69-2.46c-2.37.46-3.14 2.39-3.14 2.39a3.78 3.78 0 0 0-3.45 1.48 2.75 2.75 0 0 0 .06 3.34c.67.87 1.52 1.11 2.87 1.26.18.02.37.03.55.03h.71s3.61 2.6 7.18 0h.71c.18 0 .37 0 .55-.03 1.34-.15 2.19-.39 2.87-1.26.77-1 .79-2.33.06-3.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M15.32 3.74a4.91 4.91 0 0 0-4.51 6.85 4.9 4.9 0 0 0 6.69 2.46 4.9 4.9 0 0 0 2.73-4.4c0-2.71-2.2-4.91-4.91-4.91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.19 12.14-.47-2.92-2.92-.47c-.16-.02-.16-.25 0-.27l2.92-.47.47-2.92c.02-.16.25-.16.27 0l.47 2.92 2.92.47c.16.02.16.25 0 .27l-2.92.47-.47 2.92c-.02.16-.25.16-.27 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.56 10.36.67-1.69-.67-1.69a.08.08 0 0 1 .11-.11l1.69.67 1.69-.67c.07-.03.14.04.11.11l-.67 1.69.67 1.69a.08.08 0 0 1-.11.11l-1.69-.67-1.69.67a.08.08 0 0 1-.11-.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudInsightsBw);
export default __webpack_public_path__ + "static/media/cloud-insights-bw.af120dbe49bb0a62b2688bb20b97a60a.svg";
export { ForwardRef as ReactComponent };